module.exports = __webpack_public_path__ + "img/EGO-box.631e008b.svg";